import { relations } from 'drizzle-orm'
import { index, jsonb, pgTable, text, boolean } from 'drizzle-orm/pg-core'
import { createInsertSchema } from 'drizzle-zod'
import { createdAt, id, updatedAt } from '../utils/columns'
import { entities } from './entities.schema'
import type { DocumentTemplate } from './entities.schema'
import { receivableTypeEnum } from '../receivables/receivables.schema'

// Document templates for multiple templates per entity and document type
export const documentTemplates = pgTable(
  'document_templates',
  {
    id,
    entityId: text('entity_id')
      .notNull()
      .references(() => entities.id),
    name: text('name').notNull(),
    documentType: receivableTypeEnum('document_type').notNull(),
    template: jsonb('template').notNull().$type<DocumentTemplate>(),
    isDefault: boolean('is_default').notNull().default(false),
    createdAt,
    updatedAt,
  },
  (table) => {
    return [
      index('idx_document_templates_entity_id').on(table.entityId),
      index('idx_document_templates_document_type').on(table.documentType),
      index('idx_document_templates_entity_document_type').on(table.entityId, table.documentType),
    ]
  },
)

export type DocumentTemplateRecord = typeof documentTemplates.$inferSelect
export type DocumentTemplateInsert = typeof documentTemplates.$inferInsert

const documentTemplateInsertSchema = createInsertSchema(documentTemplates)
export const documentTemplateUserInputSchema = documentTemplateInsertSchema.omit({
  entityId: true,
  createdAt: true,
  updatedAt: true,
})

export const documentTemplatesRelations = relations(documentTemplates, ({ one }) => ({
  entity: one(entities, {
    fields: [documentTemplates.entityId],
    references: [entities.id],
  }),
}))
